import GeneralHead from "@logics/tags/GeneralHead";
import { loadPropsWithLocale } from "@logics/utils/i18n";
import Kakao from "@domains/landing/views/Kakao/Kakao";
import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";

const KaKaoLandingPage = () => {
  return (
    <>
      <GeneralHead />

      <StackLayout hideNavbar>
        <Kakao />
      </StackLayout>
    </>
  );
};

export default KaKaoLandingPage;

export const getStaticProps = loadPropsWithLocale();
